import React, { Suspense, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAppModernisation from "./hooks/useAppModernisation";
import { useFindInPageHighlighter } from "./hooks/FindInPageHooks/useFindInPageHighlighter";
import { useTableOfContentsScroll } from "./hooks/tableOfContentsHooks/useTableOfContentsScroll";
import { useOpenInModalRender } from "./hooks/OpenInModalHooks/useOpenInModalRender";
import { useDispatch, useSelector } from "react-redux";
import { setIsAppMode, setIsModernView, setIsMobileAppMode } from "./features/counter/counterSlice";
import { selectIsMobileApp } from "./store/reducers/runtimeDetails";
import TopicActionBar from "./components/TopicActionBar/TopicActionBar";
import useMobileOrientation from "./hooks/useMobileOrientation";
import ExpertGroupPopup from "./components/ExpertGroups/ExpertGroupPopup";
import UpdatesPopup from "./components/Content/UpdatesPopup";
import { useFontResize } from "./hooks/fontSizeAdjustorHooks/useFontResize";

const NavBar = React.lazy(() => import("./components/navBar"));
const MainContent = React.lazy(() => import("./components/mainContent"));
const TopicBanner = React.lazy(() => import("./components/topicBanner"));

const TopicToolsSticky = React.lazy(() => import("./components/topicToolsSticky"));
const Footer = React.lazy(() => import("./components/footer"));

const App = ({}) => {
  const navigate = useNavigate();

  const { isMobileView, isModernView } = useAppModernisation();
  const isMobileApp = useSelector(selectIsMobileApp);
  const contentRef = useRef(null);
  useFindInPageHighlighter(contentRef);
  useTableOfContentsScroll(contentRef);
  useOpenInModalRender(contentRef);
  useFontResize(contentRef);
  const { isPortrait } = useMobileOrientation();
  const dispatch = useDispatch();
  const [isExpertGroupsExpanded, setIsExpertGroupsExpanded] = useState(false);
  const [isUpdatesExpanded, setIsUpdatesExpanded] = useState(false);
  const [showTopicActionBar, setShowTopicActionBar] = useState(true);

  const expandExpertGroupsSideBar = () => {
    setIsExpertGroupsExpanded(!isExpertGroupsExpanded);
  };
  const expandUpdatesSideBar = () => {
    setIsUpdatesExpanded(!isUpdatesExpanded);
  };

  useEffect(() => {
    dispatch(setIsAppMode(isMobileView)); // in useAppModernisation isAppMode (basically runtimeDetails isMobileApp || isForcemode || isOfflineFallback)  || isMobile // isMobile true(portrait) *true(landscape) not based on rotation as no dependency on useScreenSize
    dispatch(setIsModernView(true)); // always true
    dispatch(setIsMobileAppMode(isMobileApp)); // runtimedetails once only on load- isMobileApp which is not dependent on isonSmallScreen now its win min of device and isPwaInstalled() || isForcemode || isOfflineFallback
  }, [isMobileView, isMobileApp]);

  return (
    <>
      <Suspense fallback={<div className="loader"></div>}>
        <NavBar push={navigate} />
        <TopicBanner
          push={navigate}
          expandExpertGroupsSideBar={expandExpertGroupsSideBar}
          expandUpdatesSideBar={expandUpdatesSideBar}
          setShowTopicActionBar={setShowTopicActionBar}
        />
        <MainContent ref={contentRef} />
        {isPortrait && showTopicActionBar && <TopicActionBar />}
        <TopicToolsSticky />
        <ExpertGroupPopup
          isExpanded={isExpertGroupsExpanded}
          expandSideBar={expandExpertGroupsSideBar}
        ></ExpertGroupPopup>
        <UpdatesPopup
          isExpanded={isUpdatesExpanded}
          expandSideBar={expandUpdatesSideBar}
        ></UpdatesPopup>
        {!window.Microsoft && !isModernView && <Footer />}
      </Suspense>
    </>
  );
};

export default App;
